<template>
  <div class="site-wrap">
    <div class="site-mobile-menu site-navbar-target">
      <div class="site-mobile-menu-header">
        <div class="site-mobile-menu-close">
          <span class="icon-close2 js-menu-toggle"></span>
        </div>
      </div>
      <div class="site-mobile-menu-body"></div>
    </div>

    <NavBar />

    <section class="home-section bg-dark overlay" id="home-section">
      <div class="ban">
        <div class="container"></div>
      </div>
    </section>

    <section class="site-section" id="joblist" style="background:#F8F8FB">
      <div >
        <test-crud @create="create" v-if="!isCreate" @edit-selected="openEdit"/>
        <AddUpdate  @back="isCreate=false"  v-else :item="item" :mode="mode"/>
      </div>
    </section>
  </div>
</template>

<script>
import NavBar from "@/views/NavBar.vue";
import TestCrud from "@/views/admin/test-crud";
import AddUpdate from "./add-update"

export default {
  name: "admin-test-crud",
  data() {
    return {
      isCreate:false,
      item : {},
      mode : 'create'
    }
  },
  methods: {
    create() {
      this.mode = 'create'
      this.isCreate = true
    },
    openEdit(e){
      this.item = e
      this.mode = 'update'
      this.isCreate = true
    }
  },
  components: {
    TestCrud,
    NavBar,
    AddUpdate
  }
};
</script>

<style>
.ban {
  width: 100%;
  height: 10vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ban img {
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.ban .container {
  position: relative;
  z-index: 1;
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
}
</style>
